import Immutable from 'immutable';
import { createSelector } from 'reselect';

const getPreview = state => state.get('preview', Immutable.Map());

export const selectPreviewTransactions = createSelector([getPreview], preview =>
  preview.get('previewTransactions', Immutable.Map())
);

export default {
  selectPreviewTransactions
};
